// extracted by mini-css-extract-plugin
module.exports = {"mapBtn":"map_mapBtn__1aZOD"};